module.exports = __webpack_public_path__ + "img/program_banner.30daf687.png";